import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import Modal from '../../common/modal';
import { fontSize, colours, spacing, breakpoints } from '../../../theme';
import { CONTACT_URL } from '../../../constants/navRoutes';
import { CRITERIA_TITLE, CONTACT_TITLE } from '../../../constants/titles';

const Section = styled.div`
  @media screen and (min-width: ${breakpoints.desktop}) {
    max-width: 60vw;
    margin-left: auto;
    margin-right: auto;
  }
`;

const Text = styled.p`
  font-size: ${fontSize.small};
  font-weight: ${props => props.weight || 400};
  line-height: ${spacing.small};
  text-align: ${props => props.align};
  color: ${colours.black};
  margin: ${spacing.medium};
`;

const Bold = styled.span`
  font-weight: 600;
`;

const Link = styled(NavLink)`
  color: ${colours.black};
`;

const MainLogo = styled.img`
  display: block;
  margin-right: auto;
  margin-left: auto;
  width: ${props => props.width}%;
  cursor: pointer;
`;

const SmallLogo = styled.img`
  max-width: 20%;
  max-height: 10em;
  padding: 1em;
  object-fit: contain;
  cursor: pointer;
`;

const LogoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: ${spacing.medium};
`;

const Criteria = ({ setTitle, schemesRecord, modalIsOpen, setModalIsOpen }) => {
  const [criteriaName, setCriteriaName] = React.useState(null);

  setTitle(CRITERIA_TITLE);

  const handleClick = e => {
    if (!modalIsOpen) {
      setModalIsOpen(true);
      setCriteriaName(e.target.alt);
    } else {
      setModalIsOpen(false);
    }
  };

  const renderMainScheme = (scheme, schemeName, width) => {
    if (scheme.fields.scheme_name === schemeName) {
      return (
        <MainLogo
          width={width}
          src={scheme.fields.scheme_logo_url}
          alt={scheme.fields.scheme_name}
          onClick={e => handleClick(e)}
        />
      );
    }
    return null;
  };

  const renderSmallScheme = scheme => {
    if (
      scheme.fields.scheme_name !== 'London_Living_Wage' &&
      scheme.fields.scheme_name !== 'Be_Applied'
    ) {
      return (
        <SmallLogo
          src={scheme.fields.scheme_logo_url}
          alt={scheme.fields.scheme_name}
          onClick={e => handleClick(e)}
        />
      );
    }
    return null;
  };

  return (
    <div>
      <Section>
        <Text>
          We list employers who meet the criteria that are important to us to
          demonstrate a genuine belief in the value of diversity of thought,
          beyond tick boxes. We will only work with employers who meet our
          standards around recruiting and nurturing best practice.
        </Text>
        <Text weight="600">
          To be listed on our jobs board, a company must be:
        </Text>
        <Text>1. A Living Wage employer</Text>
        {schemesRecord &&
          schemesRecord.map(scheme => {
            return renderMainScheme(scheme, 'London_Living_Wage', '50');
          })}
        <Text>
          2. A signatory to at least one of the following independent industry
          or sector diversity and inclusion pledges
        </Text>
        <LogoContainer>
          {schemesRecord &&
            schemesRecord.map(scheme => {
              return renderSmallScheme(scheme);
            })}
        </LogoContainer>
        <Text>Or using an unbiased recruitment platform</Text>
        {schemesRecord &&
          schemesRecord.map(scheme => {
            return renderMainScheme(scheme, 'Be_Applied', '30');
          })}
        <Text align="center">
          Interested in working to build a more inclusive workplace?
          <br />
          <br />
          <Link
            to={CONTACT_URL}
            title="Get In Touch"
            onClick={() => setTitle(CONTACT_TITLE)}
          >
            <Bold>CONTACT US</Bold>
          </Link>
        </Text>
      </Section>
      {!modalIsOpen ? null : (
        <Modal
          schemesRecord={schemesRecord}
          criteriaName={criteriaName}
          modalIsOpen={modalIsOpen}
          setModalIsOpen={setModalIsOpen}
        />
      )}
    </div>
  );
};

export default Criteria;
